(function () {
  'use strict';

  function initHeader(header) {
    if (!header || header.dataset.chInit === 'true') return;
    header.dataset.chInit = 'true';

    var hamburger = header.querySelector('.custom-header__hamburger');
    var drawer = header.querySelector('.custom-header__drawer');
    var overlay = header.querySelector('.custom-header__drawer-overlay');
    var closeBtn = header.querySelector('.custom-header__drawer-close');
    var isTransparent = header.dataset.transparent === 'true';
    var isSticky = header.dataset.sticky === 'true';

    function openDrawer() {
      header.classList.add('is-drawer-open');
      hamburger.setAttribute('aria-expanded', 'true');
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      header.classList.remove('is-drawer-open');
      hamburger.setAttribute('aria-expanded', 'false');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (hamburger) {
      hamburger.addEventListener('click', function () {
        var isOpen = header.classList.contains('is-drawer-open');
        if (isOpen) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && header.classList.contains('is-drawer-open')) {
        closeDrawer();
      }
    });

    /* Desktop dropdowns: click/tap toggle + outside click close, keyboard accessible */
    var dropdownToggles = header.querySelectorAll('.custom-header__menu-link--toggle');
    dropdownToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var item = toggle.closest('.custom-header__menu-item');
        var wasOpen = item.classList.contains('is-open');

        dropdownToggles.forEach(function (otherToggle) {
          var otherItem = otherToggle.closest('.custom-header__menu-item');
          otherItem.classList.remove('is-open');
          otherToggle.setAttribute('aria-expanded', 'false');
        });

        if (!wasOpen) {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!header.contains(event.target)) {
        dropdownToggles.forEach(function (toggle) {
          var item = toggle.closest('.custom-header__menu-item');
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        dropdownToggles.forEach(function (toggle) {
          var item = toggle.closest('.custom-header__menu-item');
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        });
      }
    });

    /* Mobile drawer accordion submenus */
    var drawerToggles = header.querySelectorAll('.custom-header__drawer-link--toggle');
    drawerToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = toggle.closest('.custom-header__drawer-item');
        var isOpen = item.classList.contains('is-open');

        if (isOpen) {
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* Transparent header: solid on scroll */
    if (isTransparent) {
      var scrollThreshold = 60;

      function updateScrollState() {
        if (window.scrollY > scrollThreshold) {
          header.classList.add('custom-header--scrolled');
        } else {
          header.classList.remove('custom-header--scrolled');
        }
      }

      updateScrollState();
      window.addEventListener('scroll', updateScrollState, { passive: true });
    }

    /* Reset drawer state on breakpoint change */
    var desktopQuery = window.matchMedia('(min-width: 990px)');
    desktopQuery.addEventListener('change', function () {
      closeDrawer();
    });

    /* Open Dawn's own cart drawer (if the theme uses one) instead of
       navigating to /cart. Dawn's cart-drawer.js only auto-wires the
       default header's #cart-icon-bubble link, so a custom header's cart
       icon is otherwise left doing a plain page navigation. If the theme
       isn't using a drawer cart (settings.cart_type is "page" or
       "notification"), no <cart-drawer> element exists and this link
       just falls through to its normal href, matching Dawn's own
       behavior for those cart types. */
    var cartLink = header.querySelector('.custom-header__icon--cart');
    if (cartLink) {
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', function (event) {
          event.preventDefault();
          cartDrawerEl.open(cartLink);
        });
      }
    }
  }

  /* Keep the cart count bubble live without a page refresh. Dawn's cart
     components (product forms, cart drawer, quantity inputs, etc.)
     announce cart changes through its own subscribe/publish/PUB_SUB_EVENTS
     globals (declared, unscoped, in global.js — loaded theme-wide), so we
     hook into the same channel and re-fetch /cart.js to stay in sync. This
     only needs to run once no matter how many header instances exist. */
  function initCartCountSync() {
    if (window.__customHeaderCartSyncInit) return;
    window.__customHeaderCartSyncInit = true;

    function updateCartCount(count) {
      document.querySelectorAll('.custom-header__cart-count').forEach(function (el) {
        el.textContent = count;
      });
    }

    function refreshCartCount() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
        })
        .catch(function () {
          /* Silently ignore — worst case the count stays as last rendered. */
        });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartCount);
    }

    /* Extra coverage for custom/third-party add-to-cart flows that dispatch
       a plain DOM CustomEvent instead of using Dawn's internal pub-sub. */
    ['cart:update', 'cart:refresh', 'cart:updated'].forEach(function (eventName) {
      document.addEventListener(eventName, refreshCartCount);
    });
  }

  function initAllHeaders() {
    var headers = document.querySelectorAll('custom-header');
    headers.forEach(initHeader);
    initCartCountSync();
  }

  document.addEventListener('DOMContentLoaded', initAllHeaders);
  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target.querySelector('custom-header');
    if (header) initHeader(header);
    initCartCountSync();
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAllHeaders();
  }
})();
